import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {    
    gerNumerosAtendimento(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("suporteMicrologos/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getProdutosTransacaoPorEmitente() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("suporteMicrologos/access/listaTransacoesProdutosPorEmitente").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTiposAtendimentoMicrologos() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("suporteMicrologos/access/listaTiposAtendimentoMicrologos").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getTiposOcorrenciasMicrologos() {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("suporteMicrologos/access/listaTiposOcorrenciasMicrologos").then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getOcorrenciasNA(context, idNA) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("suporteMicrologos/access/getRastreamentoSAC", {ID_EMITENTE_ATENDIM: idNA}).then(({ data }) => {
                    resolve(data);
                });                
            }
        });
    },
    solucionaNA(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("suporteMicrologos/access/fecharChamado", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarOcorrencia(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("suporteMicrologos/access/salvarOcorrencia", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    salvarChamado(context, dados) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("suporteMicrologos/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};